import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material'
import { Visibility, VisibilityOff, DragIndicator } from '@mui/icons-material'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import FormTextInput from '../UniversityCRMEntryForm/FormTextInput'
import FormSelectAutocomplete from '../UniversityCRMEntryForm/FormSelectAutocomplete'
import TextEditor from '../editor/TextEditor'
import ReasonsToChooseUs from '../UniversityCRMEntryForm/ReasonsToChooseUs'
import ChangeHistory from '../UniversityCRMEntryForm/ChangeHistory'
import SemesterWiseCurriculum from '../../pages/SemesterWiseCurriculum/SemesterWiseCurriculum'
import TopRecruiters from '../TopRecruiters/TopRecruiters'
import AveragePackageOffered from './AveragePackageOffered'
import YesNoToggal from './YesNoToggal'
import FeeAndCertForm from './FeeAndCertForm'
import MinimumQualificationSelect from './MinimumQualificationSelect'
import EntranceExamRequired from './EntranceExamRequired'
import WorkExperienceSelect from './WorkExperienceSelect'
import MinimumPercentageCGPA from './MinimumPercentageCGPA'
import ApplicationPeriodPicker from './ApplicationPeriodPicker'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { useNotification } from '../../hooks/useNotification'
import {  fetchSpecializationNameList, saveSpecialization, updateSpecializationStatus } from '../../api/specializationApi'
import { resetFields } from '../../containers/specialization-container/reducer/specializationFormSlice'
import { fetchUniversitiesNames } from '../../api/universityApi'
import { fetchCourseNames, fetchCoursesByUniversityId } from '../../api/courseApi'
import { SortableItem } from '../CourseDetails/CourseDetailsForm'
import { fetchToolsList } from '../../api/toolsApi'
import { fetchRecruiterList } from '../../api/recruiterApi'
import { updateStatus } from '../../api/adminApi'
import QuillEditor from '../editor/QuillEditor'
import { validateSchema } from '../../utils/validation/validationSchema'

const specializationOptions = [
  { label: 'Computer Science', value: 'cs' },
  { label: 'Mechanical Engineering', value: 'me' },
  { label: 'Business Administration', value: 'ba' },
  { label: 'Psychology', value: 'psych' },
]

const SpecializationDetailsForm = ({  setFields, fetchSpecialization,editMode }) => {
  const fields = useSelector(state => state.specializationForm.fields)
  const [specializationOptions, setSpecializationOptions] = useState([]);
  const location = useLocation();
  const navigate = useNavigate()
  const isReadOnly = location.state?.viewOnly ?? false;
  const { specializationId } = useParams()
  const dispatch = useDispatch()
  const specializationState = useSelector((state) => state.specializationForm)
  const { showSuccessNotification, showErrorNotification } = useNotification()
  const [universityIdOptions, setUniversityIdOptions] = useState([])
  const [courseNameOptions, setCourseNameOptions] = useState([])
  const [courseOptions, setCourseOptions] = useState([])
  const [fieldError,setFieldError] = useState(null)
  
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  )

  useEffect(() => {
    fetchUniversitiesNames(setUniversityIdOptions)
    // fetchCourseNames(setCourseNameOptions)
    // fetchCoursesByUniversityId(setCourseNameOptions)
    // fetchSpecializationNameList(setSpecializationOptions)
  }, [])

  //   useEffect(() => {
  //   if (!fields.universityId) {
  //     setCourseOptions([])
  //     return
  //   }

  //   fetchCoursesByUniversityId(
  //     fields.universityId,
  //     (courseOptions) => {
  //     }
  //   ).catch((err) => {
  //     console.log('err', err)
  //   })
  // }, [fields.universityId])

  useEffect(() => {
    fetchSpecializationNameList((rows) => {
      const options = rows.map(row => ({
        label: row.name,
        value: row.id,
      }));
      setSpecializationOptions(options);
    },{skipLimit:true});
  }, []);

  const runValidation = async (type) => {
    const errors = await validateSchema(fields, "specialization");
    setFieldError(errors);
    if (type == "submit" && Object.keys(errors?.errors).length === 0) {
      handleSpecializationSubmit()
    }
  };

  useEffect(() => {
    if (fieldError?.errors && Object.keys(fieldError.errors)?.length) {
      runValidation();
    }
  }, [fields]);
  
  useEffect(() => {
    const universityField = fields.find(f => f.id === 'universityId')
    const universityId = universityField?.value
    if (!universityId?.value) {
      setCourseOptions([])
      return
    }

    fetchCoursesByUniversityId(
      universityId?.value,
      (courseOptions) => {
        setCourseOptions(courseOptions)
      },{skipLimit:true}
    ).catch((err) => {
      console.log('err', err)
    })
  }, [fields])

  // useEffect(() => {
  //   const loadSpecialization = async () => {
  //     try {
  //       const updatedFields = await fetchSpecialization(specializationId, fields)
  //       if (updatedFields) setFields(updatedFields)
  //     } catch (err) {
  //       console.error('Error fetching specialization:', err)
  //     }
  //   }
  //   if (specializationId) {
  //     loadSpecialization()
  //   } else {
  //     dispatch(resetFields())
  //   }
  // }, [specializationId, dispatch])

  const handleDragEnd = (event) => {
    const { active, over } = event
    if (!over || active.id === over.id) return

    const oldIndex = fields.findIndex(item => item.id === active.id)
    const newIndex = fields.findIndex(item => item.id === over.id)
    setFields(arrayMove(fields, oldIndex, newIndex))
  }

  const toggleVisibility = (id) => {
    setFields(fields.map(item => item.id === id ? { ...item, visible: !item.visible } : item))
  }

  const handleSpecializationSubmit = () => {
    saveSpecialization(specializationState.fields)
      .then((data) => 
        fetchSpecialization(data?.specialization?.specialisationId))
      .then(() => {
        showSuccessNotification('Specialization saved successfully')
      })
      .catch((err) => {
        showErrorNotification(err.message || 'Failed to save specialization')
      })
  }

  const handleSpecializationApproval = () => {
    const idField = specializationState.fields.find(f => f.id === '_id')
    const objectId = idField?.value

    if (!objectId) {
      showErrorNotification('Please save specialization first')
      return
    }

    updateStatus({ id: objectId, status: "pending", type: "specialization" })
      .then(() => {
        showSuccessNotification('Specialization sent for review successfully')
        navigate(-1)
      })
      .catch((err) => {
        showErrorNotification(err.message || 'Failed to send for review')
      })
  }


  return (
    <Box display="flex" p={2} sx={{ display: 'grid', gridTemplateColumns: '1.5fr 5fr', gap: '0.5rem' }}>
      {/* LEFT SIDEBAR */}
      <Box width="100%" >
        <Box borderRight="1px solid #ccc"
          sx={{ position: 'sticky', top: '9rem', display: 'block !important', height: 'calc(100vh - 10rem)', paddingLeft: '.25rem', marginLeft: '-.25rem', overflowY: 'auto', }}>
          <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext
              items={fields}
              strategy={verticalListSortingStrategy}
            >
              {fields.map((field) => (
                <SortableItem
                  key={field.id}
                  id={field.id}
                  label={field.label}
                  visible={field.visible}
                  onToggle={() => toggleVisibility(field.id)}
                />
              ))}
            </SortableContext>
          </DndContext>
        </Box>
      </Box>

      {/* RIGHT PANEL */}
      <Box width="100%" pl={2} sx={{
        display: 'grid',
        gap: '1.5rem',
        gridTemplateAreas: `
          "intro toc"
          "content toc"
        `,
        gridTemplateColumns: '4fr 1fr',
        gridTemplateRows: 'auto 1fr',
      }}>
        <Box>
          <Typography fontWeight="bold" mb={2}>
            Specialization Details
          </Typography>
          <Grid container spacing={2}>
            {fields.map((field) => {
              if (!field.visible) return null

              if (field.id === 'universityId' || field.id === 'courseId') {
                // ... unchanged ...
                const courseIdField = fields.find(f => f.id === 'course')
                if (courseIdField?.visible) return null

                const universityField = fields.find(f => f.id === 'universityId')
                const courseField = fields.find(f => f.id === 'courseId')
                const bothVisible = universityField?.visible && courseField?.visible
                const mdSize = bothVisible ? 6 : 12

                const optionsMap = {
                  universityId: universityIdOptions,
                  courseName: courseOptions,
                  courseId: courseOptions,
                }

                const placeholders = {
                  universityId: 'Select University ID',
                  course: 'Select Course',
                }

                return (
                  <Grid size={{ xs: 12, md: mdSize }} key={field.id}>
                    <FormSelectAutocomplete
                      label={field.label}
                      placeholder={placeholders[field.id]}
                      value={field.value}
                      options={optionsMap[field.id]}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue => setFields(
                        fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue || '' } : f
                        )
                      )}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <strong>{option.label.split(' ')[0]}</strong>{' '}
                          {option.label.replace(option.label.split(' ')[0], '')}
                        </li>
                      )}
                    />
                  </Grid>
                )
              }

              if (field.id === 'specializationNameId') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <FormSelectAutocomplete
                      label={field.label}
                      value={field.value}
                      options={specializationOptions}
                      placeholder="Select Specialization"
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue => setFields(
                        fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue || '' } : f
                        )
                      )}
                    />
                  </Grid>
                )
              }

              if (field.type === 'description') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '500', mb: 1 }}>Description</Typography>
                    <TextEditor
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue => setFields(
                        fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        )
                      )}
                    />
                  </Grid>
                )
              }

              if (field.type === 'whyChooseThisSpecialisation' || field.type === 'keySkillsTaught') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <ReasonsToChooseUs
                      label={field.label}
                      placeholder="Enter Description"
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue => setFields(
                        fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        )
                      )}
                    />
                  </Grid>
                )
              }

              if (field.type === 'semesterWiseCurriculum') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '500', mb: 1 }}>Semester-wise Curriculum</Typography>
                    <SemesterWiseCurriculum
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue => setFields(
                        fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        )
                      )}
                    />
                  </Grid>
                )
              }
              // Top Recruiters
              if (field.type === 'topRecruitersId') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <TopRecruiters
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fetchList={field.type === 'toolsTechnologiesUsedId' ? fetchToolsList : fetchRecruiterList}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Average Package Offered
              if (field.type === 'averagePackageOffered') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <AveragePackageOffered
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Who Should Pursue This
              if (field.type === 'whoShouldPursueThis') {
                return (
                  <Grid size={{ xs: 12, md: 12 }}  key={`${field.id}-${specializationId}`}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '500', mb: 1 }}>
                      Who Should Pursue This?
                    </Typography>
                    <QuillEditor
                      key={`whoShouldPursueThis-${field.id}`}
                      value={field.value || ""}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue => {
                        if (specializationId && fields?.find(ele => ele?.id === 'specialisationId')?.value !== specializationId) return;

                        if (newValue !== field.value) {
                          setFields(fields.map(f =>
                            f.id === field.id ? { ...f, value: newValue } : f
                          ));
                        }
                      }}
                    />
                  </Grid>
                );
              }

              // Tools Technologies Used
              if (field.type === 'toolsTechnologiesUsedId') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <TopRecruiters
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fetchList={field.type === 'toolsTechnologiesUsedId' ? fetchToolsList : fetchRecruiterList}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Internship Mandatory
              if (field.type === 'internshipMandatory') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <YesNoToggal
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Projects Included
              if (field.type === 'projectsIncluded') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <YesNoToggal
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Minimum Qualification
              if (field.type === 'minimumQualification') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <MinimumQualificationSelect
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Minimum Percentage/CGPA
              if (field.type === 'minimumPercentageCGPA') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <MinimumPercentageCGPA
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Entrance Exam Required
              if (field.type === 'entranceExamRequired') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <EntranceExamRequired
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Work Experience Required
              if (field.type === 'workExperienceRequired') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <WorkExperienceSelect
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Stream Background
              if (field.type === 'streamBackground') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <TextEditor
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Other Requirements
              if (field.type === 'otherRequirements') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <TextEditor
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Application Period
              if (field.type === 'applicationPeriod') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <ApplicationPeriodPicker
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Admission Steps
              if (field.type === 'admissionSteps') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <ReasonsToChooseUs
                      label={field.label}
                      value={field.value}
                      placeholder="Enter Steps"
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Documents Required
              if (field.type === 'documentsRequired') {
                return <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <ReasonsToChooseUs
                      label={field.label}
                      placeholder="Document name"
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue => setFields(
                        fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        )
                      )}
                    />
                  </Grid>
              }

              // Interview Required
              if (field.type === 'interviewRequired') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <YesNoToggal
                      label={field.label}
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              // Fee and Certification Form
              if (field.type === 'feeAndCertForm') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                    <FeeAndCertForm
                      value={field.value}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue =>
                        setFields(fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        ))
                      }
                    />
                  </Grid>
                );
              }

              if (field.type === 'careerOpportunities') {
                return (
                  <Grid size={{ xs: 12, md: 12 }} key={`${field.id}-${specializationId}`}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '500', mb: 1 }}>Career Opportunities</Typography>
                    <Typography fontSize="14px" fontWeight="500" mb={1}>
                      Description
                    </Typography>
                    <QuillEditor
                      key={`careerOpportunities-${field.id}`}
                      value={field.value || ""}
                      readOnly={field.readOnly || false}
                      fieldError={fieldError?.errors?.[field?.id]}
                      fieldErrors={fieldError?.errors}
                      fieldType={field?.id}
                      onChange={newValue => {
                        if (specializationId && fields?.find(ele => ele?.id === 'specialisationId')?.value !== specializationId) return;

                        if (newValue !== field.value) {
                          setFields(fields.map(f =>
                            f.id === field.id ? { ...f, value: newValue } : f
                          ));
                        }
                      }}

                    />
                  </Grid>
                )
              }
              return (
                <Grid size={{ xs: 12, md: 12 }} key={field.id}>
                  <FormTextInput
                    label={field.label}
                    value={field.value}
                    placeholder={field.label}
                    readOnly={field.readOnly || false}
                    fieldError={fieldError?.errors?.[field?.id]}
                    fieldErrors={fieldError?.errors}
                    fieldType={field?.id}
                    onChange={newValue =>
                      setFields(
                        fields.map(f =>
                          f.id === field.id ? { ...f, value: newValue } : f
                        )
                      )
                    }
                  />
                </Grid>
              )
            })}
            <Box display="flex" gap={2} sx={{ justifyContent: 'end', mt: 3 }}>
              {
                 (!isReadOnly || editMode) && <Button sx={{ border: '1px solid #1075FF', minHeight: 'auto', padding: '4px 15px', color: '#1075FF', background: '#fff', fontSize: '14px', textTransform: 'capitalize', }}
                  onClick={()=>runValidation("submit")}
                  disabled={isReadOnly && !editMode}
                >
                  Save
                </Button>
              }
              {!isReadOnly ? <>
                {/* <Button sx={{ border: '1px solid #15243E', minHeight: 'auto', padding: '4px 15px', color: '#15243E', background: '#fff', fontSize: '14px', textTransform: 'capitalize', }}>
                  Preview
                </Button> */}
             
                {/* <Button sx={{ background: '#098B34', color: '#fff', minHeight: 'auto', padding: '4px 15px', fontSize: '14px', textTransform: 'capitalize', }}
                onClick={handleSpecializationSubmit}
                disabled={isReadOnly}
              >
                Publish
              </Button> */}
                <Button sx={{ background: '#0463EF', color: '#fff', minHeight: 'auto', padding: '4px 15px', fontSize: '14px', textTransform: 'capitalize', }}
                  onClick={handleSpecializationApproval}
                  disabled={isReadOnly}
                >
                  Send for Approval
                </Button>
              </> : <></>}
            </Box>
          </Grid>
        </Box>
        {/* <ChangeHistory /> */}
      </Box>
    </Box>
  )
}

export default SpecializationDetailsForm
